import { useLocation } from 'react-router-dom';
import { useMixpanel } from 'react-mixpanel-browser';
import { useSelector } from 'react-redux';

import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';

export function usePricingAnalytics() {
  const mixpanel = useMixpanel();
  const role = useSelector((state) => state.role);
  const { pathname } = useLocation();

  const reportToAnalytics = (actionType, params = {}) => {
    reportBusinessActionToMixpanel(mixpanel, `pricing-filter`, {
      email: role.roles.email,
      role: role.currentRole,
      type: actionType,
      pathname,
      ...params,
    });
  };

  return { reportToAnalytics };
}
